import { render, staticRenderFns } from "./company_management.vue?vue&type=template&id=598b8c80&scoped=true&"
import script from "./company_management.vue?vue&type=script&lang=js&"
export * from "./company_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598b8c80",
  null
  
)

export default component.exports